import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_TITLE = "Charles Smith & Associates";

const EXACT_ROUTES = {
  "/": `${BASE_TITLE} | Commercial Refrigeration & Kitchen Equipment`,
  "/products": `Browse Products | ${BASE_TITLE}`,
  "/products/detail": `Product Details | ${BASE_TITLE}`,
  "/contact/us": `Contact Us | ${BASE_TITLE}`,
  "/about/us": `About Us | ${BASE_TITLE}`,
  "/thankyou": `Thank You | ${BASE_TITLE}`,
  "/action": `Action Status | ${BASE_TITLE}`,
  "/dashboard": `Dashboard | ${BASE_TITLE}`,
  "/tenant/dashboard": `Tenant Admin Dashboard | ${BASE_TITLE}`,
  "/tenant-dashboard": `Tenant Admin Dashboard | ${BASE_TITLE}`,
  "/tenant/plans": `Subscription & Plans | ${BASE_TITLE}`,
  "/tenant/subscription": `Subscription & Plans | ${BASE_TITLE}`,
  "/tenant/customers": `Customer Management | ${BASE_TITLE}`,
  "/tenant/customers/add": `Invite Customer | ${BASE_TITLE}`,
  "/tenant/customers/invite": `Invite Customer | ${BASE_TITLE}`,
  "/tenant/inquiries": `Customer Inquiries | ${BASE_TITLE}`,
  "/tenant/contact-us": `Customer Inquiries | ${BASE_TITLE}`,
  "/tenant/email-templates": `Email Templates | ${BASE_TITLE}`,
  "/tenant/team": `Customer Management | ${BASE_TITLE}`,
  "/tenant/team/add": `Invite Customer | ${BASE_TITLE}`,
  "/tenant/team/invite": `Invite Customer | ${BASE_TITLE}`,
  "/orders": `My Documents & Orders | ${BASE_TITLE}`,
  "/login": `Login | ${BASE_TITLE}`,
  "/signup": `Sign Up | ${BASE_TITLE}`,
  "/forgotpassword": `Forgot Password | ${BASE_TITLE}`,
  "/reset-password": `Reset Password | ${BASE_TITLE}`,
  "/changepassword": `Change Password | ${BASE_TITLE}`,
  "/create-password": `Create New Password | ${BASE_TITLE}`,
  "/cart": `Shopping Cart | ${BASE_TITLE}`,
  "/payment/failed": `Payment Failed | ${BASE_TITLE}`,
  "/order/confirmed": `Order Confirmed | ${BASE_TITLE}`,
  "/estimate/status": `Estimate Status | ${BASE_TITLE}`,
  "/profile": `My Profile | ${BASE_TITLE}`,
  "/editprofile": `Edit Profile | ${BASE_TITLE}`,
  "/track/orders": `Track Orders | ${BASE_TITLE}`,
  "/privacy-policy": `Privacy Policy | ${BASE_TITLE}`,
  "/terms-and-conditions": `Terms & Conditions | ${BASE_TITLE}`,
};

const PREFIX_ROUTES = [
  { prefix: "/tenant/customers/detail", title: `Customer Profile | ${BASE_TITLE}` },
  { prefix: "/tenant/customers/edit", title: `Edit Customer | ${BASE_TITLE}` },
  { prefix: "/tenant/inquiries/detail", title: `Inquiry Dossier | ${BASE_TITLE}` },
  { prefix: "/tenant/contact-us/detail", title: `Inquiry Dossier | ${BASE_TITLE}` },
  { prefix: "/tenant/team/detail", title: `Customer Profile | ${BASE_TITLE}` },
  { prefix: "/tenant/team/edit", title: `Edit Customer | ${BASE_TITLE}` },
  { prefix: "/order/tracking/detail", title: `Order Tracking Detail | ${BASE_TITLE}` },
  { prefix: "/estimate/detail", title: `Estimate Details | ${BASE_TITLE}` },
  { prefix: "/invoice/detail", title: `Invoice Details | ${BASE_TITLE}` },
];

export const getTitleForPath = (pathname) => {
  if (EXACT_ROUTES[pathname]) {
    return EXACT_ROUTES[pathname];
  }

  for (const route of PREFIX_ROUTES) {
    if (pathname.startsWith(route.prefix)) {
      return route.title;
    }
  }

  return `Page Not Found | ${BASE_TITLE}`;
};

export default function RouteTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = getTitleForPath(pathname);
  }, [pathname]);

  return null;
}
